import { Component, OnInit } from '@angular/core';
import { ObservationDefinition } from 'app/mdm/lib/observation-definition/observation-definition';
import { ObservationDefinitionService } from 'app/mdm/lib/observation-definition/services/observation-definition.service';
import { Router } from '@angular/router';
import { ComponentStateStore } from '@heda/core-util';

@Component({
  templateUrl: './observation-definition-test.component.html',
})
export class ObservationDefinitionTestComponent implements OnInit {
  private STORE_KEY = 'observation-definition-test';

  public definition: ObservationDefinition;
  public value: any;
  public usage: any;
  public criteria: { [key: string]: any } = { age: 18, gender: 'male' };
  public selectedDefinitions: ObservationDefinition[] = [];
  public matchingIntervals = [];
  public iconMap = {
    error: { icon: 'exclamation-circle', color: '#e64c43' },
    critical: { icon: 'warning', color: '#f4ac13' },
    normal: { icon: 'check-circle', color: '#83d65b' },
  };

  constructor(
    private observationService: ObservationDefinitionService,
    private sessionStorageService: ComponentStateStore,
    private router: Router
  ) {}

  public ngOnInit(): void {
    const store = this.sessionStorageService.get(this.STORE_KEY);
    if (store) {
      this.definition = store.definition;
      this.selectDefinition(this.definition);
      this.usage = store.usage;
      this.value = store.value;
      this.calculate();
    }
  }

  public calculate(): void {
    this.observationService.matchInterval(this.definition, this.value, this.criteria, this.usage).subscribe((resp) => {
      this.matchingIntervals = resp.intervals;
      if (resp.val) {
        this.value[this.definition.code] = resp.val;
      }
    });
  }

  public selectDefinition(definition: ObservationDefinition): void {
    this.value = {};
    this.matchingIntervals = [];
    const definitions = [];
    definition.references.forEach((ref) => {
      definitions.push(ref.definitionReference);
    });
    definitions.push(definition);
    this.selectedDefinitions = definitions;
  }

  public isEditable = (def: ObservationDefinition): boolean => {
    return !def.calculatedValue;
  };

  public navigate(path: any[]): void {
    this.sessionStorageService.put(this.STORE_KEY, {
      definition: this.definition,
      value: this.value,
      usage: this.usage,
    });
    this.router.navigate(path);
  }
}
